const TripBannerLayout = ({ layout, value }) => {
  const icon = require('../../../assets/images/tick.svg').default
  return <></>

  ///Not need in web beacuse it is already a itinerary
  /*
  return (
    <div
      style={{
        padding: '16px 24px 32px 24px',
        // background: layout.color ? `#${layout.color}` : '',
         background: '#ff0000',
      }}
    >
        <div
        style={{
          marginTop: '10px',
          marginBottom: '10px',
          textAlign: 'left',
          color: 'var(--gray100)',
        }}
      >
        <p className="title2">
          {layout.display_name}
          </p>
      </div>
       <div
          style={{
            marginTop: '10px',
            marginBottom: '10px',
            textAlign: 'left',
            color: 'var(--gray100)',
            listStyle: 'none',
          }}
        >
          <p>
          {value.body}
          </p>
      </div>
    </div>
  )
  */
}

export default TripBannerLayout
